import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";

class Bio extends Component {
  constructor(props) {
    super(props);
    this.bioRef = React.createRef();
  }

  render() {
    return (
      <div style={bioStyle} ref={this.bioRef}>
        <div style={bioSubStyle}>
          <div style={bioHeaderContainerStyle}>
            <h1 style={bioHeaderStyle}>Biography</h1>
          </div>
          <p style={bioTextStyle}>
            Dr. Isabella Alcañiz is an Associate Professor of the{" "}
            <a href="https://gvpt.umd.edu/" target="_blank">
              Department of Government and Politics
            </a>{" "}
            and Director of the{" "}
            <a href="https://lacs.umd.edu/" target="_blank">
              Latin American and Caribbean Studies Center
            </a>
            , University of Maryland (UMD).
          </p>
          <p style={bioTextStyle}>
            Professor Alcañiz studies the politics of climate change, social
            inequality, disaster policy, and gender with a focus on Latin
            America and Latinx residents of the United States. Her research has
            been published in Global Environmental Politics, the British Journal
            of Political Science, Journal of Cleaner Production, Water Policy,
            Environmental Science & Policy, World Politics, and the Latin
            American Research Review. Her books,{" "}
            <a
              href="https://www.cambridge.org/core/elements/distributive-politics-of-environmental-protection-in-latin-america-and-the-caribbean/9AAD1CFDC6071967FC77EAC2F644EB3E"
              target="_blank"
            >
              The Distributive Politics of Environmental Protection in Latin
              America and the Caribbean
            </a>{" "}
            (2022) and the{" "}
            <a
              href="https://www.cambridge.org/core/books/environmental-and-nuclear-networks-in-the-global-south/868C8B93E787E55560E14303032040C8"
              target="_blank"
            >
              Environmental and Nuclear Networks in the Global South: How Skills
              Shape International Cooperation
            </a>{" "}
            (2016), were published by Cambridge University Press. She serves on
            the Editorial Advisory Board of Environmental Politics and Global
            Environmental Politics.
          </p>
          <p style={bioTextStyle}>
            She received a PhD from the{" "}
            <a href="https://polisci.northwestern.edu/" target="_blank">
              Department of Political Science
            </a>{" "}
            at Northwestern University and a Licenciatura in International
            Relations from the{" "}
            <a
              href="https://ub.edu.ar/facultad-de-derecho-y-ciencias-sociales/relaciones-internacionales"
              target="_blank"
            >
              Universidad de Belgrano
            </a>{" "}
            (Argentina).
          </p>
          <p style={bioTextStyle}>
            Dr. Alcañiz co-chairs the GVPT Committee on Diversity, Equity, and
            Inclusion.
          </p>
          <p style={bioTextStyle}>
            Dr. Alcañiz is a commissioner of the City of College Park
            Restorative Justice Commission.
          </p>
        </div>
      </div>
    );
  }
}

const bioStyle = {
  width: "100%",
};

const bioSubStyle = {
  maxWidth: "1100px",
  margin: "auto",
  display: "flex",
  flexWrap: "wrap",
  textAlign: "justify",
  padding: "30px 100px 80px 100px",
};

const bioHeaderContainerStyle = {
  margin: "20px auto",
};

const bioHeaderStyle = {
  fontFamily: "Lora, serif",
  fontSize: "40px",
  color: "black",
};

const bioTextStyle = {
  fontFamily: "Titillium Web, sans-serif",
  fontSize: "20px",
  color: "black",

  marginBottom: "1rem",
};

export default Bio;
